import React from 'react'
import { StyleSheet, View, ViewProps } from 'react-native'
import { useTranslation } from 'react-i18next'
import { AccessType, useCountry, useLocation } from 'zens-store'
import { Button, Text } from 'zens-storybook'

import { usePermissions } from '@dms/hook'

import { InfoBlock, InfoTable } from '../info'

const styles = StyleSheet.create({
  container: {},
  skeletonRow: {
    height: 32,
  },
  skeletonTitle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
})

interface Props extends ViewProps {
  companyId: number
  locationId: number
}
const LocationInfo = (props: Props) => {
  const { companyId, locationId, style, ...otherProps } = props
  const location = useLocation({ companyId, locationId })
  const country = useCountry({ lat: location.data?.latitude || 0, lng: location.data?.longitude || 0 })
  const { addressLine1, city } = location.data || {}
  const { t } = useTranslation()
  const { hasPermission } = usePermissions(companyId)

  const config = {
    fields: [
      {
        label: t('Address'),
        value: addressLine1,
      },
      {
        label: t('City'),
        value: city,
      },
      {
        label: t('Country'),
        value: country.data?.title,
      },
    ],
  }

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <InfoTable
        title={t('Location details')}
        companyId={companyId}
        config={config}
        buttonHref={
          hasPermission(AccessType.Update, 'location')
            ? `/companies/${companyId}/locations/${locationId}/edit`
            : undefined
        }
      />
    </View>
  )
}

interface SkeletonProps extends ViewProps {}
const Skeleton = (props: SkeletonProps) => {
  const { style, ...otherProps } = props
  const { t } = useTranslation()
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <InfoBlock.Skeleton
        title={
          <View style={styles.skeletonTitle}>
            <Text level={4}>{t('Location details')}</Text>
            <Button.Skeleton />
          </View>
        }
      >
        <Text.Skeleton style={styles.skeletonRow} />
        <Text.Skeleton style={styles.skeletonRow} />
        <Text.Skeleton style={styles.skeletonRow} />
      </InfoBlock.Skeleton>
    </View>
  )
}
LocationInfo.Skeleton = Skeleton

export default LocationInfo
